import React, { useRef, useEffect } from 'react'

const PasswordInput = ({ value, length = 5, onChange, onComplete }) => {
  const inputRef = useRef(null)
  const digits = Array(length).fill('')

  // Preenche os dígitos com o valor atual
  for (let i = 0; i < value.length; i++) {
    digits[i] = value[i]
  }

  const handleClick = () => {
    inputRef.current.focus()
  }

  const handleKeyDown = e => {
    if (e.key === 'Backspace') {
      e.preventDefault()
      const newValue = value.slice(0, -1)
      onChange(newValue)
    }
  }

  const handleChange = e => {
    const rawValue = e.target.value.replace(/\D/g, '').substring(0, length)
    const lastDigit = rawValue[rawValue.length - 1]

    // Evita digitação no meio da senha
    if (!lastDigit) return

    const newValue = (value + lastDigit).substring(0, length)
    onChange(newValue)

    if (newValue.length === length && onComplete) {
      onComplete(newValue)
    }

    // Limpa o input real pra forçar sempre só 1 caractere novo
    e.target.value = ''
  }

  // Foca automaticamente no input quando o componente monta
  useEffect(() => {
    inputRef.current.focus()
  }, [])

  return (
    <div style={{ textAlign: 'center' }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          marginBottom: '20px',
          cursor: 'text',
        }}
        onClick={handleClick}
      >
        {digits.map((digit, index) => (
          <div
            key={index}
            style={{
              width: '40px',
              height: '50px',
              margin: '0 5px',
              borderBottom: '2px solid #1890ff',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              fontSize: '24px',
              position: 'relative',
            }}
          >
            {digit ? (
              <span style={{ color: '#1890ff' }}>•</span>
            ) : (
              <span style={{ color: 'transparent' }}>•</span>
            )}
            {index === value.length && (
              <div
                style={{
                  position: 'absolute',
                  bottom: '-5px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  width: '2px',
                  height: '20px',
                  backgroundColor: '#1890ff',
                  animation: 'blink 1s infinite',
                }}
              />
            )}
          </div>
        ))}
      </div>
      <input
        ref={inputRef}
        value={value}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        style={{
          position: 'absolute',
          opacity: 0,
          height: 0,
          width: 0,
        }}
        maxLength={length}
        inputMode='numeric'
        pattern='[0-9]*'
        autoComplete='off'
        autoCorrect='off'
        autoCapitalize='off'
      />
    </div>
  )
}

export default PasswordInput
